import type { FC } from "react";
import { translate } from "app/filters/i18nFilter";
import styled from "styled-components";
import { IconButton } from "@similarweb/ui-components";
import { PlainTooltip } from "@similarweb/ui-components";
import { allTrackers } from "app/services/track/track";

const RefreshRecomendationsWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 24px;
`;

interface IRefreshRecomendations {
    onRefreshClick: VoidFunction;
}

const RefreshRecomendations: FC<IRefreshRecomendations> = ({ onRefreshClick }) => {
    const onRefreshClicked = () => {
        allTrackers.trackEvent("Button", "click", `By websites/Recommendations/Refresh`);
        onRefreshClick();
    };

    return (
        <RefreshRecomendationsWrapper data-automation="RefreshRecomendations">
            <PlainTooltip
                tooltipContent={translate("marketbuilder.refresh.recomendations.button.tooltip")}
                placement="top"
            >
                <span>
                    <IconButton
                        onClick={onRefreshClicked}
                        type="flat"
                        iconName="refresh"
                    >
                        {translate("marketbuilder.refresh.recomendations.button")}
                    </IconButton>
                </span>
            </PlainTooltip>
        </RefreshRecomendationsWrapper>
    );
};

export default RefreshRecomendations;
